import React from 'react'
import { Table, Media, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import SuccessImage from '../../images/success.png'
import { PAYMENT_SUCCESS } from '../../constants'

let PaymentSuccessModal = (props) =>
    <Modal isOpen={props.isOpen} toggle={props.toggle} className={props.className} backdrop={props.backdrop}>
        <ModalHeader>Success</ModalHeader>
        <ModalBody>
            <Media object src={SuccessImage} className="image-icon" /> &ensp;Payment Successful <br />
            <div className="col-md-12 mar-t10">
                <Table>
                    <tbody>
                        <tr>
                            <th align="right">Transacion ID</th>
                            <td align="left"><span>{props.randomPaymentId}</span></td>
                        </tr>
                        <tr>
                            <th align="right">Refrence ID</th>
                            <td align="left"><span>{props.paymentID}</span></td>
                        </tr>
                        <tr>
                            <th align="right">Amount</th>
                            <td align="left"><span>$ {(props.paymentAmount / 100)}</span></td>
                        </tr>
                        <tr>
                            <th align="right">Paid By</th>
                            <td align="left"><span>{props.paidBy}</span></td>
                        </tr>
                        <tr>
                            <th align="right">Transaction Date</th>
                            <td align="left"><span>{props.currDate}</span></td>
                        </tr>
                    </tbody>
                </Table>
            </div>
            {PAYMENT_SUCCESS}
        </ModalBody>
        <ModalFooter>
            <Button className="noprint" color="primary" onClick={props.renewSubPlan}>OK</Button>{' '}
            <Button className="noprint" color="primary" onClick={() => window.print()}>Print</Button>
        </ModalFooter>
    </Modal>

export default PaymentSuccessModal



// WEBPACK FOOTER //
// ./src/components/ui/PaymentSuccessModal.js